import * as React from 'react';
import {CPlannerTask} from '../../Entity/PlannerTaskObj';
import  './planner.scss';
import PlannerTask from './plannertask';
export interface IProps{
    data:CPlannerTask;
    Users;
    Loadpic;
    UpdateData;
    UserEmail;
    Language;
    Header;
    Phrases;
    ReloadPlannerTasks;
    Progress;
    APIHeader;
    APIServiceurl;
    CurrentUser;
}
export default class PlannerTaskCalView extends React.Component<IProps>{
    constructor(props) {
        super(props);
      }
    public render() {
        return (
                <div className='Planner' draggable onDragStart={(e)=>this.onDragStart(e)}>
                    <div  className={['calitem','ellips'].join(' ')} title={this.props.data.title}>
                    <PlannerTask data={this.props.data} 
                        Users={this.props.Users} 
                        Loadpic={this.props.Loadpic}
                        UpdateData={this.props.UpdateData}
                        UserEmail={this.props.UserEmail}
                        Language={this.props.Language}
                        Header={this.props.Header}
                        Phrases={this.props.Phrases}
                        ReloadPlannerTasks={this.props.ReloadPlannerTasks}
                        Progress={this.props.Progress}
                        APIHeader={this.props.APIHeader}
                        APIServiceurl={this.props.APIServiceurl}
                        CurrentUser={this.props.CurrentUser}
                        key={0}
                        />
                    </div>
                </div>
        );
      }
      public onDragStart=(ev)=>{

        let dragdata={
            "etag":this.props.data['@odata.etag'],
            "id":this.props.data.id,
            "type":'plannertask',
            "colno": this.props.data.col,
            "property": 'dueDateTime',
            "source":ev.target.parentElement.id
        };
        ev.dataTransfer.setData("text/plain",JSON.stringify(dragdata));
       
      }
} 